var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntradas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m0.8740025 77.049866l98.078 0l0 7.440407l-98.078 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m0.96040934 53.268112l0.0540424 -4.295971l98.02396 -22.93803l-0.054039 4.295971z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m93.77554 30.205107l5.1976013 0l0 46.8496l-5.1976013 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m50.75591 40.742706l4.0228004 0l0 36.312004l-4.0228004 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m22.726841 47.079506l3.3108006 0l0 29.975204l-3.3108006 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m3.0519083 51.559174l2.8124 0l0 25.489601l-2.8124 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m92.13201 33.661274l0 20.484833l-35.78097 4.1474l0 -16.073399z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m49.09161 43.860672l0 15.124069l-21.520203 2.3347664l0 -12.706234z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m21.261309 50.08474l0 12.012035l-13.916634 1.2964325l0 -9.938335z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m0.95150816 47.836006l98.0958 -23.421833l0 -8.9029665l-67.15643 18.669231z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m2.0106082 54.30636l0 9.568562l-1.0591 0.14725876l0 -9.571632z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntradas);
export default __webpack_public_path__ + "static/media/entradas.311f8ca741ddc674ad4ccc907007cd62.svg";
export { ForwardRef as ReactComponent };